import { IMAGE_BASE_PATH } from "@/app/utils/config";

const SubmitLoading = () => {
  return (
    <div className="gx-submit-loading">
      <div className="gx-submit-img">
        <img
          src={`${IMAGE_BASE_PATH}loadingimg.png`}
          alt="Growx loading page"
          aria-label="Growx loading page"
          width={120}
          height={120}
          loading="eager"
          decoding="async"
        />
      </div>
    </div>
  );
};

export default SubmitLoading;
